 <div
  class="toast toast--default text-white"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="toast-body text-black bg-light">
    <div class="toast__wrapper">
    <div class="toast__content">
      <div class="toast__type text-dark">Notification</div>
      <div class="toast__message">{{message}}</div>
    </div>
  </div></div>
</div>